
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/buy_gift_cards/informations",
      function () {
        return require("private-next-pages/[locale]/buy_gift_cards/informations.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/buy_gift_cards/informations"])
      });
    }
  